import querystring from 'query-string';

export const Users = {
    crud: (username="", query) => querystring.stringifyUrl({url: `/users${username}`, query}),
    accessHistory: (username="", query) => querystring.stringifyUrl({url: `/accessHistory${username}`, query}),
    forgotPassword: "/forgot-password",
    renew: (username="") => `/renewAccount${username}`,
    reactivate: (username="") => `/reactivateAccount${username}`,
    setPasswordStatus: "/users/set-password-status",
};

export const Session = (subroute="") => `/sessions${subroute}`;

export const Collection = (collectionId="", query) => querystring.stringifyUrl({url: `/collection${collectionId}`, query});
export const CollectionMER = (collectionId="", query) => querystring.stringifyUrl({url: `/entity-relationship-model${collectionId}`, query});
export const CreateCollectionIngestorDirectory = (collectionId="", query) => querystring.stringifyUrl({url: `/collection/cadastro-colecao-ingestor${collectionId}`, query});
export const DerivativeCollection = (collectionId="", query) => querystring.stringifyUrl({url: `/derivative-collection${collectionId}`, query});
export const DerivativeCollectionsUsage = (username="", query) => querystring.stringifyUrl({url: `/derivative-collections-usage${username}`, query});
export const InactivateDerivativeCollection = (collectionId="", query) => querystring.stringifyUrl({url: `/inactivate-derivative-collection${collectionId}`, query});
export const ReactivateDerivativeCollection = (collectionId="", query) => querystring.stringifyUrl({url: `/reactivate-derivative-collection${collectionId}`, query});
export const DeleteCollectionCarga = (collectionId="", query) => querystring.stringifyUrl({url: `/collection-carga${collectionId}`, query});
export const verifyCollectionAssociation = "/collection/verifyCollectionAssociation";
export const InactivateCollection = (collectionId="", query) => querystring.stringifyUrl({url: `/inactivate-collection${collectionId}`, query});
export const ReactivateCollection = (collectionId="", query) => querystring.stringifyUrl({url: `/reactivate-collection${collectionId}`, query});
export const CollectionsUsage = (username="", query) => querystring.stringifyUrl({url: `/collections-usage${username}`, query});
export const Catalog = (collectionId="", query) => querystring.stringifyUrl({url: `/catalog${collectionId}`, query});
export const ExportCatalog = (query) => querystring.stringifyUrl({url: `export-catalog`, query});
export const GetCollectionQualification = (collectionName="") => `/get-collection-qualification${collectionName}`;
export const AddNewCollectionExecution = (collectionId="") => `/add-new-collection-execution${collectionId}`;
export const AddNewCollectionTruncate = (collectionId="") => `/add-new-collection-truncate${collectionId}`;
export const getAllSystemCollections = (systemname="") => `/get-system-collections${systemname}`;
export const getAllDomainCollections = (domainname="") => `/get-domain-collections${domainname}`;
export const refreshCollectionToken = (collectionId="") => `/collection/refresh-collection-token${collectionId}`;

export const Statistics = {
    general: "/statistics/general",
    collectionStatistics: "/statistics-collections",
    collectionMongoStatistics: "/statistics-collections/mongo",
    collectionCassandraStatistics: "/statistics-collections/cassandra",
    collectionHadoopStatistics: "/statistics-collections/hadoop",
    injestorStatistics: "/statistics/ingestor",
    storageStatistics: (query) => querystring.stringifyUrl({ url: `/statistics-storage`, query }),
    storageStatisticsFilters: "/statistics-storage/filters",
    appLayerStatistics: (query) => querystring.stringifyUrl({ url: "/statistics-app-layer", query }),
    appLayerStatisticsFilters: "/statistics-app-layer/filters",
    serviceLayerStatisticsUser: (username) => `/statistics/service-layer/user/${username}`,
    serviceLayerStatisticsSystem: (systemname) => `/statistics-service-layer/system/${systemname}`,
    serviceLayerStatisticsCollection: (collectionname) => `/statistics-service-layer/collection/${collectionname}`,
};

export const IngestorMonitoring = {
  getAll: "/ingestor-monitoring"
}

export const AccessRequest = {
    crud: (request_id="", query) => querystring.stringifyUrl({url: `/access-request${request_id}`, query}),
    crudUsername: (username="", query) => querystring.stringifyUrl({url: `/access-request-user${username}`, query}),
    giveAccess: (request_id="", query) => querystring.stringifyUrl({url: `/access-request/give-access${request_id}`, query}),
    denyAccess: (request_id="", query) => querystring.stringifyUrl({url: `/access-request/deny-access${request_id}`, query}),
    removeAccess: (request_id="", query) => querystring.stringifyUrl({url: `/access-request/remove-access${request_id}`, query}),
};

export const ChangeRequest = {
    crud: (request_id="", query) => querystring.stringifyUrl({url: `/change-request${request_id}`, query}),
    crudUsername: (username="", query) => querystring.stringifyUrl({url: `/change-request-user${username}`, query}),
    giveChange: (request_id="", query) => querystring.stringifyUrl({url: `/change-request/give-change${request_id}`, query}),
    denyChange: (request_id="", query) => querystring.stringifyUrl({url: `/change-request/deny-change${request_id}`, query}),
    removeChange: (request_id="", query) => querystring.stringifyUrl({url: `/change-request/remove-change${request_id}`, query}),
};

export const SystemRequest = {
  crud: (request_id = "") => `/system-requests${request_id}`,
  profile: (request_id = "") => `/system-requests-profile${request_id}`,
  crudUsername: (username = "") => `/system-requests-user${username}`,
  giveSystem: (request_id = "") => `/system-requests-give${request_id}`,
  denySystem: (request_id = "") => `/system-requests-deny${request_id}`,
  removeSystem: (request_id = "") => `/system-requests-remove${request_id}`,
};

export const UserCollection = {
    crud: (user="", query) => querystring.stringifyUrl({url: `/associate-user-collection${user}`, query}),
    get: (colecao="undefined", usuario="undefined", sistema="undefined", query) => querystring.stringifyUrl({ url: `/associate-user-collection/${colecao}/${usuario}/${sistema}`, query }),
    updateApiToken: (association_id="") => querystring.stringifyUrl({ url: `/associate-user-collection/update-api-token${association_id}` }),
    updateJdbcPassword: (association_id="") => querystring.stringifyUrl({ url: `/associate-user-collection/update-jdbc-password${association_id}` }),
    getUserPostgresTables: (username) => querystring.stringifyUrl({ url: `/associate-user-collection/postgres-tables`, query: { username } }),
    getSystemPostgresTables: (system) => querystring.stringifyUrl({ url: `/associate-user-collection/postgres-tables`, query: { system } })
};

export const Drivers = {
  crud: (driverId="", query) => querystring.stringifyUrl({url: `/drivers${driverId}`, query}),
  getAll: `/drivers-all`,
}

export const Institutions = {
  crud: (institutionId="", query) => querystring.stringifyUrl({url: `/public-institutions${institutionId}`, query}),
  getAll: '/public-institutions-all',
  getAllInternal: '/public-institutions-all/internal',
  getAllExternal: '/public-institutions-all/external',
  reactivate: (institutionId = "") => `/reactivate-institution${institutionId}`,
};

export const AppConfig = {
  crud: (configId="") => `/app-config${configId}`,
};

export const InternalDocuments = {
  crud: (documentId="", query) => querystring.stringifyUrl({url: `/internal-documents${documentId}`, query}),
  showDocument: (documentId="") => `/show-internal-document${documentId}`,
}

export const Expressions = {
  crud: (expressionName="", query) => querystring.stringifyUrl({url: `/expression${expressionName}`, query}),
  //showDocument: (expressionName="") => `/expression${documentId}`,
}

export const EmailsConfig = {
  crud: (emailId="", query) => querystring.stringifyUrl({url: `/emails${emailId}`, query}),
  put: (emailId="", query) => querystring.stringifyUrl({url: `/emailstemplate${emailId}`, query}),
  getEmails: (page, limit, query, sort = "") => querystring.stringifyUrl({url: `/emails`, query: { page, limit, query, sort }}),
  getAll: `/emails/getAll`,
}

export const Systems = {
  item: (systemId="") => `/systems${systemId}`,
  profile: (systemId="") => `/systems-profile${systemId}`,
  getAllConsumption: '/system-all-consumption',
  getAllSource: '/system-all-source',
  getUserCatalogSystemsAvailable: (userId="", collectionId="") => `/system-user-catalog-available${userId}${collectionId}`,
};

export const Domains = {
  item: (domainId = "") => `/domains${domainId}`,
  profile: (domainId="") => `/domains-profile${domainId}`,
  getAll: '/domains-all',
};


export const fileSystem = {
  directory: (collection_id = "", item_id = "") => `/file-system/directories${collection_id}${item_id}`,
  file: (collection_id = "", file_id ="", query) => `/file-system/files${collection_id}${file_id}`,
}

export const Pipelines = {
  rud: (pipeline_id="", query) => querystring.stringifyUrl({url: `/pipeline${pipeline_id}`, query}),
  getAll: (pipelineId = "") => `/pipelines-all${pipelineId}`,
  create: (query) => querystring.stringifyUrl({url: '/pipelines-all', query}),
  save: (query) => querystring.stringifyUrl({url: '/pipelines-all/save-creation', query}),
  inactivatePipeline: (pipeline_id="", query) => querystring.stringifyUrl({url: `/inactivate-pipeline${pipeline_id}`, query}),
  collectionsLogs: (query) => querystring.stringifyUrl({url: `/pipelines-management/collections-logs`, query}),
  collectionLogs: (nome_colecao, query) => querystring.stringifyUrl({url: `/pipelines-management/collections-logs${nome_colecao}`, query}),
  logsExecution: (filePath, query) => querystring.stringifyUrl({url: `/logs-execution${filePath}`, query}),
  pipelinesLogs: (query) => querystring.stringifyUrl({url: `/pipelines-management/pipelines-logs`, query}),
  addNewPipelineExecution: (pipelineId="") => `/cronjobs/pipeline/run/${pipelineId}`,
  // addNewPipelineTruncate: (pipelineId="") => `/add-new-pipeline-truncate${pipelineId}`,
  jupyterhubFileSystem: (userId = "", directory = "") =>
    directory
      ? `/jupyterhub-file-system/directories/${userId}/${directory}`
      : `/jupyterhub-file-system/directories/${userId}`,

};

export const pipelinesAccess = {
  rud: (pipeline_access_id="", query) => querystring.stringifyUrl({url: `/pipeline-access${pipeline_access_id}`, query}),
  getAll: (userId = "") => `/pipelines-access${userId}`,
  create: (query) => querystring.stringifyUrl({url: '/pipelines-access', query}),
};
